export default __webpack_public_path__ + "static/media/icon-opensea.e73f3481.svg";